const validChanges = {
  branches_of_government: 'SUPPORT_1994',
  president_term_limit: 'LIMIT_2_TERMS',
  integration_with_foreign_countries: 'PLEBISCITE_REQUIRED',
  state_language: 'BELARUSIAN_ONLY',
  republican_referendums: 'PARLIAMENT_ONLY',
  parliament_houses_number: 'ONE_HOUSE',
};

const proposedChangesTransKeys = {
  branches_of_government: 'proposed_changes_branches_of_government',
  president_term_limit: 'proposed_changes_president_term_limit',
  integration_with_foreign_countries: 'proposed_changes_integration_with_foreign_countries',
  state_language: 'proposed_changes_state_language',
  republican_referendums: 'proposed_changes_republican_referendums',
  parliament_houses_number: 'proposed_changes_parliament_houses_number',
};

export function getProposedChanges(data) {
  if (!data) return;

  const proposedChanges = [];

  Object.keys(validChanges).forEach((key) => {
    if (validChanges[key] === data[key]) {
      proposedChanges.push(proposedChangesTransKeys[key]);
    }
  });

  // eslint-disable-next-line consistent-return
  return proposedChanges;
}

export const isEmailable = (userData) => !userData || userData.preconditions_required === 'YES';

export const showOnlyAll = (userData) => !userData || (userData && userData.preconditions_required === 'NO');
